import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Composants
import PageHero from '../components/layout/PageHero';
import Fondements from '../components/about/Fondements';
import Engagement from '../components/about/Engagement';
import Historique from '../components/about/Historique';
import Valeurs from '../components/about/Valeurs';

const APropos = () => {
  const { t } = useTranslation();

  // Mise à jour du titre de la page
  useEffect(() => {
    document.title = `${t('header.about')} | SOCABEG`;
  }, [t]);

  return (
    <div className="min-h-screen bg-white">
      <PageHero 
        backgroundImage="images/hero_apropos.png"
        title={t('about.hero.title')}
        subtitle={t('about.hero.subtitle')}
        overlayColor="socabeg-blue"
        textPosition="left"
      />

      <div className="pt-8">
        <div><Fondements /></div>
        <div><Engagement /></div>
        <div><Historique /></div>
        <div><Valeurs /></div>
      </div>
    </div>
  );
};

export default APropos;
